import axios from "axios";

/**
 * SERVICE ACCESS CONFIGURATION
 * Automatically switches between Localhost and Koyeb
 */
const isLocal = window.location.hostname === "localhost";

const API_BASE_URL = isLocal 
  ? "http://localhost:5000/api" 
  : "https://golden-shaina-maritimesupplysuites-ed826a4c.koyeb.app/api";

const ACCESS_ID = "maritime_ops_secure_2026";

const adminAxios = axios.create({
  baseURL: API_BASE_URL,
  timeout: 30000, 
  withCredentials: true,
});

/* ================= REQUEST HANDLER ================= */
adminAxios.interceptors.request.use(
  (config) => {
    const adminToken = localStorage.getItem("adminToken");
    const standardToken = localStorage.getItem("token");
    const userSession = JSON.parse(localStorage.getItem("user") || "{}");
    const adminSession = JSON.parse(localStorage.getItem("adminUser") || "{}");
    
    const activeToken = adminToken || adminSession.token || userSession.token || standardToken;
    
    if (activeToken) {
      config.headers.Authorization = `Bearer ${activeToken}`;
    }

    // Tenant Isolation Header Injection
    const activeAdminId = adminSession.adminId || userSession.adminId || localStorage.getItem("adminId");
    if (activeAdminId) {
      config.headers["x-tenant-id"] = activeAdminId;
    }

    const verificationKey = ACCESS_ID.trim();

    // Security Headers
    config.headers["x-ops-handshake"] = verificationKey; 
    config.headers["x-admin-secret"] = verificationKey;
    config.headers["admin-secret"] = verificationKey; 

    /**
     * PATH CLEANUP
     */
    if (config.url && !config.url.startsWith('http')) {
      let cleanPath = config.url;

      // Ensure paths explicitly starting with /api are preserved correctly against baseURL
      if (cleanPath.startsWith('/api/')) {
        cleanPath = cleanPath.replace('/api', '');
      }

      config.url = cleanPath.startsWith('/') ? cleanPath : `/${cleanPath}`;
    }

    // Content-Type handling
    if (!(config.data instanceof FormData)) {
      config.headers["Content-Type"] = "application/json";
    }

    return config;
  },
  (error) => Promise.reject(error)
);

/* ================= RESPONSE HANDLER ================= */
adminAxios.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response) {
      const { status } = error.response;
      if (status === 401 || status === 403) {
        console.warn("[SECURITY] Access denied or tenant scope violation.");
      }
    }
    return Promise.reject(error);
  }
);

export default adminAxios;